export default __webpack_public_path__ + "static/media/MoonBanner.6f294e60.jpg";